module.exports = __webpack_public_path__ + "img/guide-mobile.108cb5f5.gif";